
/** 神策埋点数据接收端，与 F2E-harbour-web 共用同一接收服务 */
const SENSORS_SERVER_URL = `${location.origin}/api/system-alert-ticket-server/frontend/logs`
import router from '../router'

let initialized = false

const getCurrentPageName = () => {
  try {
      if(router && router.currentRoute && router.currentRoute.meta){
        return router.currentRoute.meta.title
      }
    return ''
  } catch {
    return ''
  }
}

export const initSensors = () => {
  if (initialized) return
  const sensors = window.sensorsDataAnalytic201505
  if (!sensors) {
    console.warn('[sensors] sensorsdata.min.js 未加载，跳过埋点初始化')
    return
  }

  sensors.init({
    server_url: SENSORS_SERVER_URL,
    is_track_single_page: true, // 单页面配置：URL 变化自动触发 $pageview
    use_client_time: true,
    send_type:'beacon', //  content-type:text/plain
    heatmap: {
      clickmap: 'default', //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      scroll_notice_map: 'not_collect', // 关闭触达图
    },
  })

  // if (userInfo.huid) { sensors.login(String(userInfo.huid)) };
 let userInfo = {}
 if(window.localStorage.getItem('currentUserInfo')){
  try {
    userInfo = JSON.parse(window.localStorage.getItem('currentUserInfo')) 
  } catch (error) {
    console.log(error)
  }
 }

  sensors.registerPage({                 // 添加公共属性数据
    platform_type: '集卡车老板A-TMS',
    user_name: userInfo?.name,
    // group: webphoneInfo?.dispatcherGroup,
    service_name: "duckbill-agent-tms",
    // service_version: __APP_VERSION__,
    page_name: getCurrentPageName,
  })

  initialized = true
}